var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"devider",style:({ margin: _vm.margin })})
}
var staticRenderFns = []

export { render, staticRenderFns }